// "/duplicate/getDuplicates";
import FnrFetch3 from "Utilities/FnrFetch/FnrFetch3.js";
import { fnThrowError } from "Utilities/fnReportError";

export const getDuplicates = async () => {
  const endpoint = "/duplicate/getDuplicates";
  const fetchFunction = new FnrFetch3(endpoint);
  const response = await fetchFunction.post().catch((err) => {
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    });
  });

  return response;
};

export const getDuplicateCount = async () => {
  const endpoint = "/duplicate/getDuplicateCount";
  const fetchFunction = new FnrFetch3(endpoint);
  const response = await fetchFunction.post().catch((err) => {
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    });
  });

  return response;
};